export interface MemberFormData {
  [propertyName: string]: any;

  consents?: { [consentName: string]: boolean };
}

export interface MemberValidationResponse {
  valid: boolean;
  errors?: MemberValidationResult;
}

export interface MemberValidationResult {
  properties?: any[];
  email?: any[];
  registration_password?: any[];
}

export class MemberValidationError extends Error {
  constructor(public readonly validationErrors: MemberValidationResult) {
    super('Member validation error');
  }
}
